import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Box, Chip, Tooltip, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { fmtDateTime } from '../../Utils/format';

const STATUS_COLORS = {
  ONLINE: 'success',
  OFFLINE: 'error',
  ERROR: 'error',
  MAINTENANCE: 'warning',
};

const DeviceStatusIndicator = ({ status, deviceName, lastHeartbeat, showLabel = true }) => {
  const { t } = useTranslation('common');
  const color = STATUS_COLORS[status] || 'default';
  const label = t(`deviceStatus.${status?.toLowerCase()}`, { defaultValue: status });
  const lastSeen = lastHeartbeat
    ? fmtDateTime(lastHeartbeat)
    : t('deviceStatus.unknown');

  return (
    <Tooltip
title={`${t('deviceStatus.lastSeen')}: ${lastSeen}`}
arrow
    >
      <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
        {deviceName && <Typography variant="body2">{deviceName}</Typography>}
        <Chip
          icon={<CircleIcon sx={{ fontSize: 10 }} />}
          label={showLabel ? label : undefined}
          color={color}
          size="small"
          sx={{ height: showLabel ? 22 : 18 }}
        />
      </Box>
    </Tooltip>
  );
};

DeviceStatusIndicator.propTypes = {
  status: PropTypes.string.isRequired,
  deviceName: PropTypes.string,
  lastHeartbeat: PropTypes.string,
  showLabel: PropTypes.bool,
};

export default DeviceStatusIndicator;
